import React, {useState} from 'react'
import {GoogleMap, MarkerF, OverlayView, useJsApiLoader} from '@react-google-maps/api';
import charger_icon from '../../assets/charger_icon.svg'

import LoadingAnimation from "../Utils/BateryChargeAnimation/index.jsx";
import ConnectorPopUp from "../Connector/ConnectorPopUp/index.jsx";
import {unwindConnectors} from "../../Utils/connectors.js";
import useIsMobile from "../../Utils/isMobileHook.js";

import './styles.scss'


const googleMapsStyling = {
    width: '100%',
    height: '100%',
    borderRadius:'20px',
};

const Map = ({ chargingPoints }) => {
    const [chargePointId, setChargePointId] = useState(false)
    const [mapCenter, setMapCenter] = useState({  lat: 46.77724331229473, lng: 23.58938780469352})

    const isMobile = useIsMobile()

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: `${import.meta.env.VITE_GOOGLE_MAPS}`
    })

    const openGoogleMaps = (latitude,longitude) => {
        const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(url, '_blank');
    }

    return isLoaded ? (
        <div className={'map_container'} >
             <GoogleMap
                mapContainerStyle={googleMapsStyling}
                center={mapCenter}
                zoom={13}
                options={{mapId: "de25441e38fe05ab", gestureHandling:"cooperative"}}
            >
                {chargingPoints.map((chargePoint, idx) => {
                    const lat = parseFloat(chargePoint?.location?.coordinates?.[0])
                    const lng = parseFloat(chargePoint?.location?.coordinates?.[1])
                    const connectors =  unwindConnectors(chargePoint)

                    if(lat && lng){
                        return <MarkerF animation={2} key={idx} position={{lat:lat, lng:lng}} icon={charger_icon} opacity={chargePointId === chargePoint.cp_id ? 0.1 : 1} onClick={()=>{setChargePointId(chargePoint.cp_id); setMapCenter({
                            lat,
                            lng
                        })}}>
                            {!isMobile && chargePointId === chargePoint.cp_id && <OverlayView mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} position={{lat:lat, lng:lng}}>
                                <ConnectorPopUp lat={lat} lng={lng} connectors={connectors} openGoogleMaps={openGoogleMaps} setChargePointId={setChargePointId}/>
                            </OverlayView>}
                            { isMobile && chargePointId === chargePoint.cp_id && <ConnectorPopUp lat={lat} lng={lng} connectors={connectors} openGoogleMaps={openGoogleMaps} setChargePointId={setChargePointId}/>}
                        </MarkerF>
                    }
                    })
                }
            </GoogleMap>
        </div>
    ) : <LoadingAnimation/>
}


export default Map